import { Box } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import moment from 'moment';
import { gridShortDate } from 'utilities';
import { FinancialsDateSelectorProps } from './FinancialsDateSelector.props';

const FinancialsDateSelector = ({ onDateChange, currentDate, disabled = false }: FinancialsDateSelectorProps) => {
  const handleDateChange = (date: Date | null) => {
    if (date) {
      const formattedDate = gridShortDate(date);
      onDateChange(formattedDate);
    }
  };

  return (
    <Box sx={{ ml: 1.5 }}>
      <DatePicker
        label="Financials Date"
        value={currentDate ? moment(currentDate).toDate() : null}
        format="MM/dd/yyyy"
        onChange={handleDateChange}
        openTo="day"
        views={['year', 'month', 'day']}
        disabled={disabled}
      />
    </Box>
  );
};

export default FinancialsDateSelector;
